import React, { useState, useEffect } from 'react';
import '../../styles/Home/BannerSection.css';

const bannerData = [
  {
    id: 1,
    destination: 'Rajasthan',
    tagline: 'LAND OF KINGS AND PALACES',
    image: 'https://www.theindiatourism.com/images/rajasthan-tour.jpg',
    logo: '/assets/logo.png'
  },
  {
    id: 2,
    destination: 'Kerala',
    tagline: 'GOD\'S OWN COUNTRY AWAITS',
    image: 'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2000&q=80',
    logo: '/assets/logo.png'
  },
  {
    id: 3,
    destination: 'Himachal',
    tagline: 'ADVENTURE IN THE MOUNTAINS',
    image: 'https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2000&q=80',
    logo: '/assets/logo.png'
  },
  {
    id: 4,
    destination: 'Goa',
    tagline: 'BEACHES, SUNSETS & SERENITY',
    image: 'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2000&q=80',
    logo: '/assets/logo.png'
  },
];

const BannerSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = bannerData.length;

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [totalSlides]);

  // Navigation functions
  const goToNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const goToPrevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="banner-section">
      <div className="banner-slider">
        {bannerData.map((banner, index) => (
          <div 
            key={banner.id} 
            className={`banner-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${banner.image})` }}
          >
            <div className="banner-content">
              <p className="banner-tagline">{banner.tagline}</p>
              <h2 className="banner-destination">{banner.destination}</h2>
              <div className="banner-logo-container">
                <img src={banner.logo} alt="Travel Partner Logo" className="banner-logo" />
                <div className="banner-divider"></div>
                <div className="banner-destination-logo">{banner.destination}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Navigation Arrows */}
      <button className="banner-nav banner-prev" onClick={goToPrevSlide}>
        <span>&lt;</span>
      </button>
      <button className="banner-nav banner-next" onClick={goToNextSlide}>
        <span>&gt;</span>
      </button>
      
      {/* Pagination Dots */}
      <div className="banner-pagination">
        {bannerData.map((_, index) => (
          <span 
            key={index} 
            className={`pagination-dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default BannerSection;
